var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09606 5.64647L1.7425 6.00002L2.09606 6.35358L6.17106 10.4286C6.2336 10.4911 6.24961 10.5413 6.24961 10.6C6.24961 10.6587 6.2336 10.7089 6.17106 10.7715C6.10851 10.834 6.05833 10.85 5.99961 10.85C5.94089 10.85 5.89071 10.834 5.82816 10.7715L1.32816 6.27147C1.29372 6.23702 1.26985 6.2001 1.25328 6.15752C1.23418 6.10734 1.22461 6.05587 1.22461 6.00002C1.22461 5.94454 1.23406 5.8927 1.25326 5.8416C1.26967 5.80002 1.29345 5.76329 1.32816 5.72858L5.82816 1.22858C5.89071 1.16603 5.94089 1.15002 5.99961 1.15002C6.05833 1.15002 6.10851 1.16603 6.17106 1.22858C6.2336 1.29112 6.24961 1.3413 6.24961 1.40002C6.24961 1.45875 6.2336 1.50893 6.17106 1.57147L2.09606 5.64647Z",
    fill: "#707683",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft2);
export default __webpack_public_path__ + "static/media/arrow-left2.1a6ae890.svg";
export { ForwardRef as ReactComponent };